export enum BaseCustomerOfferActions {
  default = '',
  accept = 'accept',
  reject = 'reject',
}
